<template>
    <div>
        <van-sticky>
            <van-nav-bar title="商品评价" left-arrow @click-left="$router.go(-1)" />
        </van-sticky>
        <van-field v-model="form.content" type="textarea" placeholder="请输入您的评价" show-word-limit />
        <van-cell title="评价图片">
            <div slot="default">
                <van-uploader :after-read="upWx">
                    <img :src="form.image" alt v-if="form.image!=''" class="aliImg" />
                    <img src="../../assets/imgs/personal/upImg.png" alt class="aliImg" v-else />
                </van-uploader>
            </div>
        </van-cell>
        <van-button class="evaBtn" @click='evaSubmit'>立即提交</van-button>
    </div>
</template>
<script>
    import { fileUpload } from "@/api/personal";
    import { evaluate } from "@/api/home";
    export default {
        data() {
            return {
                form: {
                    order_id: '',
                    image: "",
                    content: ""
                }
            }
        },
        created() {
            this.form.order_id = this.$route.query.id;
            console.log(this.form.order_id);
        },
        methods: {
            upWx(file) {
                let formData = new FormData();
                formData.append("image", file.file);
                fileUpload(formData).then(res => {
                    this.form.image = res.path;
                });
            },
            evaSubmit() {
                if (this.form.content == '') {
                    this.$toast('请填写评价内容!');
                    return;
                }
                evaluate(this.form).then(res => {
                    setTimeout(() => {
                        this.$router.replace({ path: 'myOrder', query: { status: 0, active: 0 } })
                    }, 200)
                })
            }
        }
    }
</script>
<style scoped lang='less'>
    .aliImg {
        width: 120px;
        height: 120px;
    }

    .evaBtn {
        width: 345px;
        background: #3B6BFB;
        color: #fff;
        height: 44px;
        margin: 30px auto;
        display: block;
        line-height: 44px;
        border-radius: 22px;
    }
</style>